// @flow

import styled from '@emotion/styled'

import Col from './Col';

const LabelCell = styled(Col)`
  flex-basis: 150px;
  text-align: right;
  padding-right: 10px;
  align-self: center;
`;

export default LabelCell;
